import {
  ROLE_PROOF_READER,
  ROLE_SYSTEM_ADMIN,
  ROLE_PROJECT_MNG,
  ROLE_QA_EXPERT,
  ROLE_LSP,
} from '@/utils/const.js';

export default [
  {
    path: '/projects/:view?/filters/tasks/',
    name: 'projects',
    component: () => import('@/views/projects/index.vue'),
    meta: {
      baseRoute: 'projects',
      title: 'Tasks list',
      middleware: {
        access: 'auth',
        rules: [
          ROLE_PROOF_READER,
          ROLE_SYSTEM_ADMIN,
          ROLE_PROJECT_MNG,
          ROLE_QA_EXPERT,
          ROLE_LSP,
        ],
      },
    },
  },
  {
    path: '/projects/detail/:id',
    name: 'project_detail',
    component: () => import('@/views/projects/project_detail/index.vue'),
    meta: {
      baseRoute: 'projects',
      title: 'Task detail',
      middleware: {
        access: 'auth',
        rules: [
          ROLE_PROOF_READER,
          ROLE_SYSTEM_ADMIN,
          ROLE_PROJECT_MNG,
          ROLE_QA_EXPERT,
          ROLE_LSP,
        ],
      },
    },
  },
];
